
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Ein Schläfchen, das man tagsüber einlegt, sollte nicht länger als 20 Minuten dauern. Nur dann fühlt man sich nach dem Aufwachen ausgeruht und gut. Während dieser Zeitspanne befindet sich der Körper noch in einem Leichtschlaf. Wer länger schlummert, fühlt sich dagegen oft «verknittert» und schlaftrunken. Menschen, die mit Schlafproblemen zu kämpfen haben, sollten laut Medizinern ganz darauf verzichten – es brächte ihren Schlafrhythmus zusätzlich durcheinander. Allen anderen kann ein Mittagsschlaf Energie für die zweite Tageshälfte geben. Und er kann die Muskeln entspannen und Stress lösen. Zumindest kurzfristig. Ein Nickerchen soll sich zudem positiv auf die Leistungsfähigkeit auswirken. `}<M mdxType="M">{`«Studien haben zeigen können, dass ein Powernap die Leistungsfähigkeit um bis zu 35 Prozent steigern kann»`}</M>{`, sagt der Schlafexperte Jürgen Zulley. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;